import { render } from "./PdfPreview.vue?vue&type=template&id=e4a30a8a&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"

import "./PdfPreview.vue?vue&type=style&index=0&id=e4a30a8a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a30a8a"]])

export default __exports__